import { IEngagement } from "@wingspanhq/payments/dist/interfaces";
import { WSInfiniteQueryConfig } from "@ws-react-query";

import { useAllFromInfiniteQuery } from "../../../shared/hooks/useAllFromInfiniteQuery";
import { WSServiceError } from "../../../utils/serviceHelper";
import {
  EngagementListQueryParams,
  useQueryEngagementList
} from "./useQueryEngagementList";

export const useQueryEngagementsListAll = (
  params?: EngagementListQueryParams,
  config?: WSInfiniteQueryConfig<IEngagement[], WSServiceError>
) => {
  const infiniteQuery = useQueryEngagementList(
    { ...params },
    { refetchOnMount: false, retry: false, ...config }
  );

  return useAllFromInfiniteQuery(infiniteQuery);
};
